import AgendaItem from "@/domain/entities/agenda/AgendaItem";
import Email, { MailsListId } from "@/domain/entities/emails/Email";
import MailDraft from "@/domain/entities/emails/MailDraft";
import MailActionType from "@/domain/enums/MailActionType";
import { createContext, useContext } from "react";

export type VistassistantMailContextValue = {
    isVistassistantResult: boolean;
    // actionType: the reply/forward asked from a mail's actions (MailAction); the assistant opens
    // the mail in its side panel, read-only.
    onMailClick?: (
        mail: Email,
        listId: MailsListId,
        actionType?: MailActionType,
    ) => void;
    /** An event of the chat opens in the side panel; absent, it unfolds in its line. */
    onEventClick?: (event: AgendaItem) => void;
    /**
     * « Ouvrir dans MailVista » on an assistant's draft: written in the side panel, under what is
     * open (a reply also opens the mail it answers).
     */
    /** A choice of an assistant's question, clicked: sent as the user's next message. */
    onAnswerQuestion?: (reply: string) => void;
    /** « Autre… » under a question: the cursor goes to the assistant's input. */
    onFocusInput?: () => void;
    onComposeDraft?: (
        key: string,
        draft: MailDraft,
        replyTo?: {
            mail: Email;
            listId: MailsListId;
            actionType: MailActionType;
        },
    ) => void;
};

const defaultValue: VistassistantMailContextValue = {
    isVistassistantResult: false,
};

export const VistassistantMailContext =
    createContext<VistassistantMailContextValue>(defaultValue);

export const useVistassistantMail = () => useContext(VistassistantMailContext);
